import { EoWriter, Item, PacketAction, PacketFamily, type EoReader } from 'eolib';
import type { Client } from '@/client';
import { GameState } from '@/game-state';

const FAMILY = 55 as PacketFamily;
export type Hunt = { slot:number; name:string; npc_name:string; target:number; progress:number; item_name:string; item_amount:number; experience:number; claimed:boolean };
export type HuntSnapshot = { enabled:boolean; reset_at:string; hunts:Hunt[]; message?:string; error?:string; inventory?:{id:number;amount:number}[]; stats?:Record<string,number> };
export type HuntViewState = { snapshot?:HuntSnapshot; pending:boolean; message:string };
type Store = { state:HuntViewState; listeners:Set<()=>void>; timeout:number; registered:boolean };
const stores = new WeakMap<Client,Store>();
function store(client:Client):Store {
 let s=stores.get(client);if(!s){s={state:{pending:false,message:''},listeners:new Set(),timeout:0,registered:false};stores.set(client,s);}return s;
}
function update(s:Store,state:HuntViewState){s.state=state;for(const notify of s.listeners)notify();}
export function getDailyHunts(client:Client){return store(client).state;}
export function subscribeDailyHunts(client:Client,notify:()=>void){const s=store(client);s.listeners.add(notify);return ()=>{s.listeners.delete(notify);};}
export function requestDailyHunts(client:Client,slot=0):boolean {
 const s=store(client);if(client.state!==GameState.InGame||s.state.pending)return false;
 if(slot && s.state.snapshot && Date.now()>=Date.parse(s.state.snapshot.reset_at)) {
  update(s,{...s.state,message:"A new day has started. Loading today's hunts…"});
  requestDailyHunts(client);return false;
 }
 if(slot){const h=s.state.snapshot?.hunts.find(h=>h.slot===slot);if(!h||h.claimed||h.progress<h.target||!s.state.snapshot?.enabled)return false;}
 update(s,{...s.state,pending:true,message:slot?'Claiming…':s.state.message});
 const writer=new EoWriter();if(slot)writer.addChar(slot);
 clearTimeout(s.timeout);s.timeout=window.setTimeout(()=>update(s,{...s.state,pending:false,message:'No response yet. Refresh to check your claim; rewards cannot be claimed twice.'}),6000);
 try{client.bus.sendBuf(FAMILY,slot?PacketAction.Use:PacketAction.List,writer.toByteArray());}
 catch{clearTimeout(s.timeout);update(s,{...s.state,pending:false,message:'Connection unavailable. Please reconnect.'});return false;}
 return true;
}
export function registerDailyHunts(client:Client){
 const s=store(client);
 if(!s.registered){s.registered=true;client.subscribeStateChanged(state=>{if(state!==GameState.InGame){clearTimeout(s.timeout);update(s,{pending:false,message:''});}});}
 client.bus.registerPacketHandler(FAMILY,PacketAction.Reply,(reader:EoReader)=>{
  let data:HuntSnapshot;try{data=JSON.parse(reader.getString());}catch{return;}
  if(!data.error&&!Array.isArray(data.hunts))return;
  clearTimeout(s.timeout);
  if(data.inventory){client.inventoryController.items=data.inventory.map(x=>{const i=new Item();i.id=x.id;i.amount=x.amount;return i;});client.inventoryController.refreshEnhancementDisplay();}
  if(data.stats){for(const key of ['level','experience','statPoints','skillPoints','hp','tp','maxHp','maxTp'] as const){if(Number.isFinite(data.stats[key]))client[key]=data.stats[key];}client.statsController.notifyStatsUpdated();}
  update(s,{snapshot:data.error?s.state.snapshot:data,pending:false,message:data.error||data.message||''});
 });
}
